<script>
export default {
	mounted() {
		console.log("FILTER_SESSION_CALLED", this.filter);
		let filter_key =
				"filter_ID:" +
				this.$inertia.page.props.user?.id +
				this.$inertia.page.component,
			filter = JSON.parse(sessionStorage.getItem(filter_key));
		if (filter) {
			console.log("SESSION_STORAGE_UPDATE", filter);
			this.filter = filter;
			if (this.applyFilter) {
				this.applyFilter();
			}
		}
	},
	watch: {
		filter: {
			deep: true,
			handler() {
				let filter_key =
					"filter_ID:" +
					this.$inertia.page.props.user?.id +
					this.$inertia.page.component;
				sessionStorage.setItem(filter_key, JSON.stringify(this.filter));
				console.log(
					"SESSION_STORAGE_WATCH_UPDATE",
					filter_key,
					sessionStorage.getItem(filter_key)
				);
			},
		},
	},
};
</script>
